import BaseApi from '~/api/base';
class RecentActivity extends BaseApi {
    constructor() {
        super('/recent-activity');
    }
    getDocuments() {
        return super.route('/recent-activity/documents').get();
    }
    getDocumentComparisons() {
        return super.route('/recent-activity/document-comparisons').get();
    }
}
const RecentActivityApi = new RecentActivity();
export default RecentActivityApi;
